
  // Usage example:

  // <div className="custom-select" data-title="<?= get_field('title_when_filtered', $type) ?>">
  //   <label htmlFor="years-<?= $type->term_id ?>"><?= $type->name ?></label>
  //   <select id="years-<?= $type->term_id ?>" className="js-year-select" data-num="<?= $k + 1 ?>"
  //           data-type="<?= $type->term_id ?>">
  //     <option value=""><?= opt('all_years') ?></option>
  //
  //     <?php if ($years): foreach ($years as $k=> $v): ?>
  //     <option value="<?= $v->term_id ?>"><?= $v->name ?></option>
  //     <?php endforeach; endif; ?>
  //   </select>
  // </div>


  let customSelects = $('.custom-select')

  export function initCustomSelect(selects){
    selects.each(function(){
      let options = $(this).find('option')
      let optionsHtml = ''
      let firstEmpty = $(this).data('first-empty') ? $(this).data('first-empty') : 0
      let title = firstEmpty ? '' : options.first().text()

      if (firstEmpty) $(this).addClass('nothing-selected')

      $(this).append('<div class="select-selected"><div class="title">'+ title +'</div></div>')

      options.each(function(i){
        optionsHtml+= '<div class="select-option '+ (i === 0 && !firstEmpty ? 'same-as-selected' : '' ) +'" value="'+ $(this).attr('value') +'" >'+ $(this).text() +'</div>';
      })

      $(this).append('<div class="select-items select-hide">'+ optionsHtml +'</div>')

    })
  }
  initCustomSelect(customSelects)


  // Open Dropdown
  $(document).on('click','.select-selected',function(){
    $(this).parent().find('.select-items').toggleClass('select-hide')
  })

  // Click on dropdown el
  $(document).on('click','.select-option',function(){
    let selectEl = $(this).parent().parent()
    let select = selectEl.find('select')
    let val = $(this).attr('value')
    select.val(val).change()
  })

  // Select Change Event
  $(document).on('change','.custom-select select',function(){
    let selectEl = $(this).parent()
    let selected = selectEl.find('.select-selected .title')
    let dropdown = selectEl.find('.select-items')
    let title = $(this).find('option:selected').text()
    let value = $(this).val()

    // add selected class to dropdown
    dropdown.find('.select-option').each((i, el)=>{
      el.classList.remove('same-as-selected')
      if (el.getAttribute('value') === value) el.classList.add('same-as-selected')
    })

    selected.text(title)


    dropdown.addClass('select-hide')
    if (title === '') {
      selectEl.addClass('nothing-selected')
    } else {
      selectEl.removeClass('nothing-selected')
    }


  })


  // Close dropdowns when clicked away
  $(document).click(function (e) {
    e.stopPropagation();

    $('.custom-select').each(function () {
      if (e.target !== $(this).find('.select-selected')[0] && e.target !== $(this).find('.title')[0]) {
        $(this).find('.select-items').addClass('select-hide')
      }
    })
  })



